<homey-lotteries-dialog-content
  singleTitle="Application not selected"
  multipleTitle="Applications not selected"
  singleDescription="Unfortunately, this application was not selected by the HPD. Keep applying, new opportunities open regularly!"
  multipleDescription="Unfortunately, these applications were not selected by the HPD. Keep applying, new opportunities open regularly!"
  [notification]="data()"
  [closeButton]="closeButton()"
>
  <ng-template lotteryDialogListItem let-lottery>
    <homey-lottery-list-item [apartment]="lottery" [openInPopup]="true">
      <p>Not selected</p>
    </homey-lottery-list-item>
  </ng-template>
</homey-lotteries-dialog-content>
